import { Component, OnInit, Input, ViewEncapsulation } from '@angular/core';

import { SharedFunctionService } from '../../../services/common/shared-function.service';
import * as models from '../../../shared/models';
import { Vehicle } from '../../../../lib/angular/model/vehicle/vehicle';
import { OmnitureTags } from 'src/app/shared/omnitureTags';
import { BehaviorSubject } from 'rxjs';
import { isDefined } from '../../../../lib/core/library';
import { getFullModelText } from "../helpers/util";
import { ActivatedRoute } from '@angular/router';
import { NOT_APPLICABLE } from '../../constants/app.constants';
import { VSpecDetailService } from '../../../features/v-spec/detail/v-spec-detail.service';
import { MatDialog } from '@angular/material/dialog';
import { CommentsDialogComponent } from './comments-dialog/comments-dialog.component';



@Component({
  providers : [OmnitureTags],
  selector: 'dd-vehicle-detail-header',
  templateUrl: './vehicle-detail-header.component.html',
  styleUrls: ['./vehicle-detail-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VehicleDetailHeaderComponent implements OnInit {
  vehicleModel = "";
  // Field to store Shared Data from store
  @Input()
  sharedData: models.SharedData = <models.SharedData>{};

  @Input()
  showIndicator: Boolean = true;

  @Input()baseMrspDisclaimer: string = '';
  @Input() tsrpDisclaimer: string = '';

  @Input('vehicleDetails')
  set vehicleDetails(value: any) {
    this._vehicleDetails = value;
    this.vehicleModel = getFullModelText(value);
    if (!this._vehicleDetails) {
      if (!this._vehicleDetails.media) {
        this.imgExterior = this._vehicleDetails.media.filter(x => x.type === 'exterior');
        if (this.imgExterior.length > 3) {
          this.imgExterior = this.imgExterior.slice(0, 4);
        }
        this.imgInterior = this._vehicleDetails.media.filter(x => x.type === 'interior');
        if (this.imgInterior.length > 3) {
          this.imgInterior = this.imgInterior.slice(0, 4);
        }
      }
      if (this._vehicleDetails.model && this._vehicleDetails.model.modelCd) {
        const _showEbrochureLink = this._EBROCHURE_MODEL_CODE_WHITELIST.some(whitelist => this._vehicleDetails.model.modelCd.startsWith(whitelist));
        this.showEbrochure.next(_showEbrochureLink);
      }
      if (isDefined(this._vehicleDetails.year)) {
        const modelMarketingName = this.sharedFunctionService.getModelMarketingName(this._vehicleDetails).toLowerCase();
        this.eBrochureURL = `https://www.toyota.com/content/ebrochure/${this.vehicleDetails.year}/${modelMarketingName}_ebrochure.pdf`;
      }
    } else {
      if (this._vehicleDetails && this._vehicleDetails.media) {
        this.imgExterior = this._vehicleDetails.media
          .filter(x => x.type === 'exterior')
          .sort((a, b) => a.source === 'PORT' ? -1 : 1);
        if (this.imgExterior.length > 3) {
          this.imgExterior = this.imgExterior.slice(0, 4);
        }

        this.imgInterior = this._vehicleDetails.media
          .filter(x => x.type === 'interior')
          .sort((a, b) => a.source === 'PORT' ? -1 : 1);
        if (this.imgInterior.length > 3) {
          this.imgInterior = this.imgInterior.slice(0, 4);
        }
      }
    }
    if(!this._vehicleDetails.stockNum || this._vehicleDetails.stockNum.length === 0) {
       this._vehicleDetails.stockNum = NOT_APPLICABLE;
    }
  }

  get vehicleDetails(): any {
    return this._vehicleDetails;
  }

  @Input('dealerDetails')
  set dealerDetails(value: any) {
    this._dealerDetails = value;
  }

  get dealerDetails(): any {
    return this._dealerDetails;
  }
  public isPrintWithComments:boolean=false;
  public showEbrochure: BehaviorSubject<boolean> = new BehaviorSubject(false);
  carouselActiveExt = true;
  imageUrl: string;
  imgExterior: any[] = [];
  imgInterior: any[] = [];
  hideImageCarouselNavigation = true;
  public eBrochureURL: string;
  public deleteVin = false;
  private _vehicleDetails: any;
  private _dealerDetails: any;
  comments:string;
  private readonly _EBROCHURE_MODEL_CODE_WHITELIST = ['4544', '4550', '24', '23'];

  constructor(public sharedFunctionService: SharedFunctionService,
              public omTag: OmnitureTags,
              public vSpecDetailService: VSpecDetailService,
              private route: ActivatedRoute, 
              public dialog: MatDialog) {
    this._vehicleDetails = new Vehicle();
   }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.deleteVin = !!params['id'];
    });

    this.route.parent.queryParams.subscribe(queryParams => {
      this.isPrintWithComments=queryParams['print'];
      if(this.isPrintWithComments)
        {
         this.printPDF();
        }
    });
  }

  carouselActive(mode: string) {
    this.carouselActiveExt = (mode === 'EXT');
  }

  swipe(event: any) {
    const x = Math.abs(event.deltaX) > 40 ? (event.deltaX > 0 ? 'prev' : 'next') : '';
    if ( x === 'prev' || 'next') {
      document.getElementById('carousel-' + x + '-nav').click();
    }
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(CommentsDialogComponent, {
      panelClass: 'custom-dialog-container',
      data: {dealerDetails: this.dealerDetails}
    },
  );
    dialogRef.afterClosed().subscribe(result => {
      this.comments = result?.data;
      if(result && result.printPDF) {
        this.vSpecDetailService.downloadVSpecPDF(this.baseMrspDisclaimer, this.tsrpDisclaimer, this.deleteVin, this.comments, true);
      } 
    });
  }

  printPDF() {
    this.openDialog();
  }

  async downloadPDF($event){
    this.vSpecDetailService.downloadVSpecPDF(this.baseMrspDisclaimer, this.tsrpDisclaimer, this.deleteVin, this.comments, false);
    this.omTag.fireOmnitureTag(
      "vd_km-other-download",
      {
        url: "", href: "",
        text: $event.srcElement.innerText,
        trigger: "km-link"
      },
      this.sharedData
    );
  }

  getTruncatedStr(str: string) {
    return str && str.substr(11, 6) || '';
  }
}
